import { Config } from "../utils/config";

export const createContact = async (ContactDetails ) => {
    console.log( ContactDetails );
    return fetch(`${Config.BaseUrl}/contact-uses`, {
      method: "POST",
      body: JSON.stringify({ data: ContactDetails }),
      headers: { "Content-Type": "application/json" },
    });
  };

  export const getContactInfo = async () => {

    const url = `${Config.BaseUrl}/sub-categories?filters[Sub_category_URL][$eq]=contact-us&populate=*`
    return fetch(url).then((res) => res.json())
  }